module.exports = __webpack_public_path__ + "img/monitor-icon-dark.7f81a917.svg";